import React from 'react';
import styled from 'styled-components';
import Supercashback from '@catalogo/ui-americanas-mobile-supercashback';
import BestPrice from '@catalogo/ui-americanas-mobile-best-price';
import PaymentOption from '@catalogo/ui-americanas-mobile-payment-option';
import ArrowRight from '@catalogo/ui-americanas-desktop-svg/arrow.svg';
import { formatPrice } from '@catalogo/core-helpers/price';
import { Nav } from '@catalogo/core-nav';
import { withPaymentOption } from '@catalogo/service-americanas-product/src/payment';
import { replaceUrlParams } from '@catalogo/service-americanas-product/src/helpers/url';
import ExclusivePrime from './components/exclusive-prime';
import { SecondaryOption } from './components/secondary-option';

export const Buybox = ({
  isExclusivePrimeDiscount,
  buyTogether,
  defaultPrice,
  mainPayment,
  secondaryPayment,
  hasSuperCashback,
  contentModalAme,
  prime,
  international,
  history,
  variantB,
}) => {
  const modalLink = '#modal-payment-methods';

  const renderMorePaymentMethods = () => (
    <PaymentMethods onClick={replaceUrlParams(history, modalLink, false)}>
      mais formas de pagamento
      <ArrowRight fill="#666" width="12px" height="12px" transform="rotate(270)" />
    </PaymentMethods>
  );

  const renderMorePaymentMethodsSmall = () => (
    <PaymentMethodsSmall onClick={replaceUrlParams(history, modalLink, false)}>
      mais formas de pagamento
    </PaymentMethodsSmall>
  );

  if (buyTogether) {
    return (
      <Wrapper>
        <Price>{`R$ ${formatPrice(buyTogether)}`}</Price>
        <Label>com item sugerido</Label>
      </Wrapper>
    );
  }

  return (
    <Wrapper variantB={variantB}>
      {isExclusivePrimeDiscount && <ExclusivePrime />}
      <Supercashback hasSuperCashback={hasSuperCashback} contentModalAme={contentModalAme} />
      <BestPrice international={international} prime={prime} payment={mainPayment} defaultPrice={defaultPrice} />
      <PaymentOption payment={mainPayment} />
      <SecondaryOption payment={secondaryPayment} />
      {variantB ? renderMorePaymentMethodsSmall() : renderMorePaymentMethods()}
    </Wrapper>
  );
};

const Price = styled.div`
  font-size: 30px;
  line-height: 1.2;
  font-weight: 600;
  text-align: left;
  line-height: normal;
  margin: 0px;
`;

const Label = styled.div`
  padding-bottom: 20px;
`;

const Wrapper = styled.div`
  width: 100%;
  padding: ${({ variantB }) => (variantB ? '0 20px 10px 20px' : '20px 20px 0px')};
  background: #fff;
  border-radius: 4px;
  margin: 0 auto;
  color: #666;
  font-size: 14px;
  ${({ variantB }) =>
    !variantB &&
    `@media (max-width: 768px) {
    box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 4px;
  }`}
`;

const PaymentMethods = styled(Nav)`
  border: 0;
  background-color: transparent;
  padding: 0;
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  border-top: 1px solid rgba(206, 204, 204, 0.4);
  padding: 20px 0px;
  color: #666;
  width: 100%;
  font-size: 14px;

  &:focus,
  &:active {
    border: 0;
    outline: 0;
  }
`;

const PaymentMethodsSmall = styled(Nav)`
  display: block;
  padding-top: 10px;
  font-size: 14px;
  text-decoration: underline;
`;

export default withPaymentOption(Buybox);
